<template>
  <div class="modal animated fadeIn fast">
    <div
      class="modal-overlay"
      @click.stop="closeModal()"
      :class="{
        lg: size === 'large',
        sm: size === 'small',
        md: size === 'medium'
      }"
    >
      <div
        class="modal-container"
        @click="$event.stopPropagation()"
        :class="{
          pink: theme === 'pink',
          expandWidth: customWidth,
          expandHeight: customHeight
        }"
        :style="{
          height: title ? modalHeight + 50 + 'px' : modalHeight + 'px',
          overflow: scrollable ? 'auto' : 'unset'
        }"
      >
        <div
          v-if="closeable"
          class="modal-header"
          :class="{ 'close-icon': close, title: title }"
        >
          <div class="list-header">
            <h1 class="title" v-if="title">{{ title }}</h1>
          </div>
          <i class="el-icon-close" v-if="close" @click="closeModal()"></i>
        </div>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  data() {
    return {
      close: true,
      modalHeight: 300
    };
  },
  props: {
    scrollable: { type: Boolean, default: true },
    closeable: { type: Boolean, default: true },
    theme: { type: String, default: "white" },
    title: { type: String },
    size: { type: String },
    customHeight: { type: Boolean, default: false },
    customWidth: { type: Boolean, default: false }
  },
  methods: {
    closeModal() {
      this.$emit("close", true);
    },
    handleResize() {
      const el = document.getElementById("text");
      if (el) {
        this.modalHeight = el.clientHeight + 110;
        if (window.innerHeight < this.modalHeight) {
          this.modalHeight = window.innerHeight - 80;
        }
      }
    }
  },
  mounted() {
    const content = this.$el;
    const body = document.querySelector("body");
    body.appendChild(content);

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/styles.scss";

.modal {
  position: fixed;
  display: block;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  z-index: 99;
  h1 {
    text-align: left !important;
    text-transform: uppercase;
    font-weight: 600 !important;
    line-height: 18px;
    margin-bottom: 0.5rem !important;
  }
  .modal-overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.4);
    .modal-container {
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
      width: auto;
      max-width: 50%;
      margin: auto;
      padding: 25px 70px;
      color: $grey-dark-color;
      background: $white-color;
      border-radius: 30px;
      overflow: auto;
      -webkit-box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.64);
      -moz-box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.64);
      box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.64);
      .modal-header {
        position: relative;
        display: block;
        padding: 0px;
        min-height: 50px;
        width: 100%;
        border-bottom: 0px;
        margin-bottom: 10px;
        color: black;
        display: flex;
        align-items: center;
        &.el-icon-close {
          padding-right: 40px;
        }
        &.title {
          text-align: left;
          min-height: 100px;
          border-top: 1px solid $grey-dark-color;
          border-bottom: 1px solid $grey-dark-color;
          .el-icon-close {
            color: $pink-color;
          }
        }
        h1 {
          text-align: center;
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 0px;
          padding-top: 10px;
          line-height: 28px;
          width: 80%;
        }
        .el-icon-close {
          position: absolute;
          right: 10px;
          font-size: 50px;
          cursor: pointer;
        }
      }
      label {
        color: black;
        font-weight: 500;
        font-size: 28px;
        margin: 10px 0px;
      }
      &.pink {
        padding: 24px 30px;
        background: $pink-color;
        .el-icon-close {
          color: $white-color;
        }
        label {
          color: $white-color;
          font-weight: 200;
          font-size: 28px;
          line-height: 28px;
        }
      }
    }
    &.sm {
      .modal-container {
        width: 420px;
        text-align: center;
      }
    }
    &.lg {
      .modal-container {
        max-width: 85%;
      }
    }
  }

  .expandWidth {
    width: 80% !important;
  }
  .expandHeight {
    height: 80% !important;
  }
}

@media screen and (max-width: 992px) {
  .modal .modal-overlay .modal-container,
  .modal .modal-overlay.lg .modal-container {
    max-width: 90%;
  }
}

@media (max-width: 800px) {
  .modal {
    .btn {
      width: 215px;
    }
  }
}

@media (max-width: 650px) {
  .modal {
    .modal-overlay.sm {
      .modal-container {
        max-width: 90%;
      }
    }
    .modal-container {
      padding: 30px 35px !important;
      .modal-header {
        h1 {
          font-size: 20px !important;
        }
      }
      &.pink {
        label {
          font-size: 28px !important;
        }
      }
    }
  }
}
</style>
